<div class="container-fluid">
<div class="content-main">
    <div class="">
        <div id="content">
            <div class="content-main">
                <div>
                  <div role="navigation">
                    <div class="flex-row w-100 mb-2">
                      <div class="" style="">
<app-main-menu></app-main-menu>
                      </div>
                    </div>
                    <div id="messages" class=""><app-messages></app-messages></div>
<router-outlet></router-outlet>
                  </div>
                </div>
            </div><!-- end content-main -->
        </div><!-- end content -->
    </div>
    <app-footer></app-footer>
    <router-outlet name="popup"></router-outlet>
</div><!-- end container-fluid-->
</div><!-- end content-main -->
